<template>
    <IntlTelInput
        @changeCountry="countryChanged"
        :name="name"
        :id="id"
        :required="required"
        :value="modelValue"
        :options="{
            initialCountry: countryCode,
        }"
    />
    <input type="hidden" :name="countryCodeName" :value="countryCode" />
</template>

<script setup>
import { ref, computed } from "vue";

import IntlTelInput from "intl-tel-input/vue";

const props = defineProps({
    id: {
        type: String,
        default: () => null,
    },
    name: {
        type: String,
        default: () => null,
    },
    required: {
        type: Boolean,
        default: () => false,
    },
    modelValue: {
        type: Number|String,
        default: () => null,
    },
    flag: {
        type: String,
        default: () => "PT",
    },
});

const countryCode = ref(props.flag && props.flag.trim() !== "" ? props.flag : "PT");
const countryCodeName = computed(() => {
    if (props.name && props.name.includes('[')) {
        return props.name.replace(/(\w+)(\[\d+\])\[(\w+)\]/, '$1$2[$3_country]');
    }

    return `${props.name}_country`;
});

const countryChanged = (country) => {
    countryCode.value = country.toUpperCase();
};
</script>

